import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("bonza_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-transparent border-b-2 border-border focus:border-brand outline-none py-3 text-lg transition-colors";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between bg-primary text-primary-foreground p-12 grain relative">
        <Link to="/" className="relative z-[2] font-serif text-3xl tracking-tight">Salons For Sale</Link>
        <h1 className="relative z-[2] font-serif font-light text-6xl leading-[0.95] tracking-tight">
          Lead
          <br />
          Console
        </h1>
        <span className="relative z-[2] eyebrow text-primary-foreground/50">
          Salons For Sale &middot; in association with Bonza
        </span>
      </div>

      <div className="flex items-center justify-center p-8">
        <motion.form
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          onSubmit={submit}
          className="w-full max-w-sm"
          data-testid="admin-login-form"
        >
          <div className="eyebrow text-brand mb-4">Administrator</div>
          <h2 className="font-serif font-light text-4xl tracking-tight mb-10">Sign in</h2>

          <label className="eyebrow text-muted-foreground">Email</label>
          <input
            data-testid="admin-email"
            className={`${field} mb-6`}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            autoComplete="username"
          />
          <label className="eyebrow text-muted-foreground">Password</label>
          <input
            data-testid="admin-password"
            className={field}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            autoComplete="current-password"
          />

          {error && <p className="text-destructive text-sm mt-4" data-testid="admin-login-error">{error}</p>}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="mt-10 w-full rounded-full bg-primary text-primary-foreground py-4 eyebrow hover:bg-brand transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in\u2026" : "Sign In"}
          </button>
        </motion.form>
      </div>
    </div>
  );
}
